<template>
    <div class="sustainable-component manage-developmentblocks">
        <div class="container-fluid mt-3">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div v-html="$t('workorganisation_tab4_tool_create_block_text')"></div>
                    <v-form v-model="valid" ref="form">
                        <v-select data-testid="development-block-position-select" bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="jobPositionItems" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                        <div class="row">
                            <div class="col-12">
                                <v-text-field v-bind:disabled="disabled" :rules="[rules.integer]" bg-color="white" name="jobBlockNumber"
                                              data-testid="development-block-number-input"
                                              id="jobBlockNumber"
                                              :type="'text'"
                                              v-bind:label="$t('workorganisation_tab4_tool_create_block_nr')"
                                              variant="outlined"
                                              v-model="jobBlockNumber">
                                </v-text-field>
                            </div>
                            <div class="col-12">
                                <v-text-field v-bind:disabled="disabled" :rules="[rules.required]" bg-color="white" name="jobBlockName"
                                              data-testid="development-block-name-input"
                                              id="jobBlockName"
                                              :type="'text'"
                                              v-bind:label="$t('workorganisation_tab4_tool_create_block_name')"
                                              variant="outlined"
                                              v-model="jobBlockName">
                                </v-text-field>
                            </div>
                            <div class="col-12">
                                <v-btn data-testid="development-block-add-button" v-bind:disabled="disabled" class="bg-primary mb-3"
                                       variant="text"
                                       @click="addWorkBlock">
                                    {{$t('workorganisation_tab4_tool_create_block_add_block_button')}}
                                </v-btn>
                            </div>
                        </div>
                    </v-form>
                </div>
                <div class="col-12 col-md-6">

                    <table data-testid="development-block-table" class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-5">{{$t('workorganisation_tab4_tool_create_block_nr')}}</th>
                                <th class="col-5">{{$t('workorganisation_tab4_tool_create_block_name')}}</th>
                                <th class="col-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item) in jobPositionBlocks" :key="item.Id" :data-testid="`development-block-row-${item.Id}`" :data-block-name="item.Name" :data-block-number="item.BlockNumber">
                                <td class="col-6">
                                    <span v-if="selected != item">{{item.BlockNumber}}</span>
                                </td>
                                <td class="col-5">
                                    <span v-if="selected != item">{{item.Name}}</span>
                                </td>
                                <td class="col-1">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" @click="changeJobPositionBlock(item)" class="dropdown-item">Ändra</a>
                                                <a href="javascript:void(0)" @click="deleteJobPositionBlock(item.Id)" class="dropdown-item">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdatedevelopmentBlock ref="updateblockdialog" v-bind:disabled="disabled" @updated="reload"></UpdatedevelopmentBlock>

    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import WorkOrganisationService from "../../Services/WorkOrganisationService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import UpdatedevelopmentBlock from '../workorganisation/update-developmentblock.vue'
    
    import { ref } from 'vue'
    const form = ref(null);
    const updateblockdialog = ref(null);

    export default {

        name: 'manage-developmentblocks',
        emits: ['positionSelected', 'position-selected'],
        props: {
            model: Object,
            selectedJobPosition: [String, Number],
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
            UpdatedevelopmentBlock
        },
        methods: {
            normalizeJobPositionId(value) {
                if (value === null || value === undefined || value === '') {
                    return null;
                }

                var asNumber = Number(value);
                return Number.isNaN(asNumber) ? value : asNumber;
            },
            syncJobPositionsFromModel() {
                this.internalModel = this.model;
            },
            setSelectedJobPositionFromProp(newVal) {
                var id = this.normalizeJobPositionId(newVal);
                if (id === null) {
                    return;
                }

                if (this.selectedPosition !== id) {
                    this.selectedPosition = id;
                }
            },
            ensureInitialSelection() {
                this.syncJobPositionsFromModel();
                this.setSelectedJobPositionFromProp(this.selectedJobPosition);

                if ((this.selectedPosition === null || this.selectedPosition === undefined || this.selectedPosition === '')
                    && this.jobPositionItems.length > 0) {
                    this.selectedPosition = this.jobPositionItems[0].JobPositionId;
                }
            },
            reload(){
                this.getWorkBlocks(this.selectedPosition);
            },
            changeJobPositionBlock(item) {
                this.loading++;
                this.updateblockdialog.open(item)
                this.loading--;
            },
            async getWorkBlocks_old(id) {
                this.loading++;
                try {
                    this.jobPositionBlocks = await WorkOrganisationService.getJobPositionblocks(id);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async getWorkBlocks(id) {
                const reqId = ++this.blocksReqId;
                this.loading++;

                try {
                    const blocks = await WorkOrganisationService.getJobPositionblocks(id);

                    // Om användaren hunnit välja en annan position efter att vi startade:
                    if (reqId !== this.blocksReqId) return;

                    this.jobPositionBlocks = blocks;
                } catch (e) {
                    if (reqId !== this.blocksReqId) return;
                    this.displayErrorSnackBar("Kunde inte hämta block");
                } finally {
                    // bara senaste requesten får påverka loading
                    if (reqId === this.blocksReqId) this.loading--;
                    else this.loading--; 
                }
            },
            async addWorkBlock() {
                
                var result = await this.form.validate();
                if (result.valid != true)
                    return;

                if (!this.selectedPosition) {
                    this.displayErrorSnackBar("Välj en befattning först");
                    return;
                }

                for (var i = 0; i < this.jobPositionBlocks.length; i++) {
                    if(this.jobPositionBlocks[i].BlockNumber.toString() == this.jobBlockNumber.toString())
                    {
                        this.displayErrorSnackBar("Blocknummer måste vara unikt")
                        return;
                    }
                }

                this.loading++;
                try {
                    await WorkOrganisationService.addJobPositionDevelopmentBlock(this.selectedPosition, this.jobBlockName, this.jobBlockNumber);
                    this.displaySnackBar("Sparat");
                    this.getWorkBlocks(this.selectedPosition);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async deleteJobPositionBlock(id) {
                if (confirm(" Är du säker att du vill radera blocket?")) {
                    this.loading++;
                    try {
                        await WorkOrganisationService.deleteJobPositionDevelopmentBlock(id);
                        this.displaySnackBar("Borttaget");
                        this.getWorkBlocks(this.selectedPosition);
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                rules: ValidationService.rules(),
                internalModel:{
                    JobPositions: []
                },
                blocksReqId: 0,
                jobPositionBlocks: [],
                jobBlockName: '',
                jobBlockNumber: null,
                selectedPosition: null,
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null
            };
        },
        computed: {
            jobPositionItems() {
                var list = this.internalModel && Array.isArray(this.internalModel.JobPositions)
                    ? this.internalModel.JobPositions
                    : [];
                var selectedId = Number(this.selectedJobPosition || this.selectedPosition);
                if (Number.isNaN(selectedId) || selectedId <= 0) {
                    return list;
                }

                var selected = [];
                var rest = [];
                for (var i = 0; i < list.length; i++) {
                    var row = list[i];
                    var id = row && row.JobPositionId !== undefined ? row.JobPositionId : row && row.jobPositionId;
                    if (Number(id) === selectedId) {
                        selected.push(row);
                    }
                    else {
                        rest.push(row);
                    }
                }

                return selected.concat(rest);
            },
        },
        watch: {
            selectedPosition: function(newVal){
                if (newVal === null || newVal === undefined || newVal === '') {
                    return;
                }
                this.getWorkBlocks(newVal);
                this.$emit('positionSelected', newVal)
                this.$emit('position-selected', newVal)
            },
            selectedJobPosition: function (newVal) {
                this.setSelectedJobPositionFromProp(newVal);
            },
            'model.JobPositions': function (newList, oldList) {
                if (newList !== oldList) {
                    this.syncJobPositionsFromModel();
                    this.setSelectedJobPositionFromProp(this.selectedJobPosition);
                }
            },
        },
        created() {
            this.ensureInitialSelection();
        },
        mounted() {
            this.ensureInitialSelection();
        },
        setup() {
            return { updateblockdialog,form }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
